// utils/nsamlPermissions.js
import { doc, getDoc } from "firebase/firestore";
import { firestore as db } from "../../../../backend/firebaseconfig";

export async function canUserAccessAML(userEmail) {
  if (!userEmail) return false;

  const ref = doc(db, "Compliance", "Check²");
  const snap = await getDoc(ref);

  if (!snap.exists()) return false;

  const data = snap.data();
  const users = Array.isArray(data?.users)
    ? data.users.map((e) => e.toLowerCase())
    : [];

//   console.log("Resolved adviserAdmins:", admins);

  return users.includes(userEmail.toLowerCase());
}
